import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18 21.5C19.933 21.5 21.5 19.933 21.5 18C21.5 16.067 19.933 14.5 18 14.5C16.067 14.5 14.5 16.067 14.5 18C14.5 19.933 16.067 21.5 18 21.5Z'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M30.25 11H5.75V25H30.25V11Z'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M30.25 15.375C29.157 15.1897 28.1487 14.6691 27.3648 13.8852C26.5809 13.1013 26.0603 12.093 25.875 11'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M25.875 25C26.0603 23.907 26.5809 22.8987 27.3648 22.1148C28.1487 21.3309 29.157 20.8103 30.25 20.625'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M5.75 20.625C6.843 20.8103 7.85132 21.3309 8.63521 22.1148C9.4191 22.8987 9.93975 23.907 10.125 25'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M10.125 11C9.93975 12.093 9.4191 13.1013 8.63521 13.8852C7.85132 14.6691 6.843 15.1897 5.75 15.375'
      stroke={props.stroke}
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
export default SvgMoney
